import CreativeStudio from "../features/creativeStudio";

export default function CreativeStudioPage() {
  return <CreativeStudio />;
}





